<template>
  <header>
    <ul class="menu">
      <img class="logo" src="../assets/vi/login/logo.png" alt="" />
      <li v-for="(nav, index) in navs" :key="index">
        <a :href="nav.url">{{ nav.name }}</a>
        <div class="line-box">
          <div class="line"></div>
        </div>
      </li>
      <li v-show="userInfo.token.length == 0">
        <a href="/account">Đăng nhập</a>
        <div class="line-box">
          <div class="line"></div>
        </div>
      </li>
      <!-- <li
        v-show="userInfo.token.length > 0"
        style="position: relative"
        @click="showLogout = !showLogout"
      > -->
      <li v-show="userInfo.token.length > 0" style="position: relative" @click="logout2">
        <a
          >Đăng xuất
          <!-- <i style="margin-left: 5px; margin-bottom: 0px" class="icon icon-down"></i
        > -->
          <img style="width: 10px" src="../assets/vi/payNew/down.png" alt="" />
        </a>
        <div class="line-box">
          <div class="line"></div>
        </div>
        <div class="user-handle" :class="{ active: showLogout }">
          <div class="mask"></div>
          <!-- <div class="user-handle-item to-user">個人中心</div> -->
          <div class="user-handle-item logout" @click="logout2">Đăng xuất nhanh</div>
        </div>
      </li>
    </ul>
  </header>
</template>

<style lang="css">
header {
  position: relative;
  position: fixed;
  width: 100%;
  height: 90px;
  /* background: #181d1f; */
  background: url("../assets/vi/payNew/bg-header.png");
  z-index: 99;
  display: flex;
  align-items: center;
  padding-right: 20px;
}

header .logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 100%;
}

header .menu {
  flex: 1;
  text-align: right;
}

header .menu li {
  display: inline-block;
  position: relative;
  margin-right: 56px;
  cursor: pointer;
}

header .menu li a {
  font-size: 26px;
  /* color: #fff; */
  /* 使用线性渐变作为背景 */
  background: linear-gradient(
    to bottom,
    rgb(210, 183, 128),
    rgb(255, 241, 200),
    rgb(193, 167, 109)
  );

  -webkit-background-clip: text;
  background-clip: text;

  color: transparent;

  font-weight: 600;
  text-decoration: none;
}

header .menu li .line-box {
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: -9px;
}

header .menu li .line-box .line {
  width: 0%;
  height: 100%;
  margin: 0 auto;
  background: linear-gradient(
    to bottom,
    rgb(210, 183, 128),
    rgb(255, 241, 200),
    rgb(193, 167, 109)
  );
  transition: 0.2s ease-in-out;
}

header .menu li:hover .line-box .line,
header .menu li.active .line-box .line {
  width: 100%;
}

header .user {
  margin-left: 63px;
  display: inline-block;
}
header .user .no-login {
  display: block;
}
header .user .no-login .xm-btn {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  margin-left: 5px;
  border-radius: 5px;
  background-image: linear-gradient(180deg, #f2c487 50%, #d69826 90%);
  color: #000;
}
header .user .user-login {
  position: relative;
  width: 140px;
  align-items: center;
  justify-content: space-between;
  display: flex;
  cursor: pointer;
}
header .user .user-login .user-img {
  margin-right: 4px;
  width: 22px;
  height: 26px;
}
header .user .user-login .user-img img {
  width: 100%;
  height: 100%;
}
header .user .user-login .user-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  color: #fff;
}
.icon-user-down {
  width: 12px;
  height: 8px;
  background-repeat: no-repeat;
  background-image: url("@/assets/other/icon-user-down.png");
  background-size: 100% 100%;
}
.user-handle {
  display: none;
  position: absolute;
  top: 100%;
  padding: 9px 0 6px;
  text-align: center;
}
.user-handle .mask {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
}
.user-handle .user-handle-item {
  position: relative;
  font-size: 16px;
  color: #787878;
  width: 140px;
  background: #fff;
  z-index: 1;
}
.user-handle .user-handle-item:hover {
  background: #d7d7d7;
}
.user-handle .user-handle-item:first-child {
  border-bottom: 1px solid #333333;
}
.user-handle.active {
  display: block;
}

@media (max-width: 700px) {
  header {
    height: 100px;
  }
}
</style>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  props: {},
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      navs: [
        // { name: 'Trang Chủ', url: '/' },
        { name: "Nạp tiền", url: "/pay" },
      ],
      showLogout: 0,
    };
  },
  mounted() {},
  methods: {
    ...mapMutations(["logout"]),
    logout2() {
      this.logout();
      this.$router.replace("/account");
    },
    handleClick() {
      console.error("11");
      this.showLogout = 0; // !this.showLogout;
      console.error(this.showLogout);
    },
  },
};
</script>
